import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

const Chapter34 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);


    return (
        <>
                 {/* Chapter 34 */}
                <section id="section34" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter34Title}</h2>

                    <ul className="drivers-handbook-list">
                        <li>{language.chapter34List11}
                        </li>
                        <li>{language.chapter34List12}</li>
                        <li>{language.chapter34List13}</li>
                        <li>{language.chapter34List14}
                        </li>
                        <li>{language.chapter34List15}
                        </li>
                        <li>{language.chapter34List16}
                        </li>
                        <li>{language.chapter34List17}</li>
                    </ul>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter34Paragraph1}
                    </p>
                </section>

        </>
    )

}

export default Chapter34;
